import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import { Form } from 'react-bootstrap';
import styles from './ArchivedSearch.module.scss';
import { CommonSearchProps } from './interfaces';
import { useFormat } from '../../../../helpers/hooks/useFormat';
import { useProductList } from '../../organisms/product/product-list/context';
import LoadingIcon from '../button/loadingIcon';

export const ArchivedSearch = ({ queryKey, placeholder }: CommonSearchProps) => {
  const router = useRouter();
  const { appendQueryParams, removeQueryParams } = useProductList();
  const { slug, ...query } = router.query;
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const _ = slug; // Extracted but not used
  const { formatMessage: formatCommonMessage } = useFormat({ name: 'common' });
  const [value, setValue] = useState((query[queryKey] as string) || '');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const handleComplete = () => {
      setLoading(false);
    };

    if (loading) {
      router.events.on('routeChangeComplete', handleComplete);
      router.events.on('routeChangeError', handleComplete);
    } else {
      router.events.off('routeChangeComplete', handleComplete);
      router.events.off('routeChangeError', handleComplete);
    }

    return () => {
      router.events.off('routeChangeComplete', handleComplete);
      router.events.off('routeChangeError', handleComplete);
    };
  }, [router.events, loading]);

  const submit = () => {
    const new_query = { [queryKey]: value };
    appendQueryParams(new_query);
  };

  const handleOnSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    if (value.length === 1) {
      return;
    }

    setLoading(true);
    submit();
  };

  const clearSearch = () => {
    setLoading(true);
    setValue('');
    removeQueryParams([queryKey]);
  };

  return (
    <div className={styles['search-container']}>
      {loading && (
        <div className={styles.loading}>
          <LoadingIcon className="fill-gray-700" />
        </div>
      )}
      <Form className={`d-flex ${styles['search-field']}`} onSubmit={handleOnSubmit}>
        <Form.Control
          type="search"
          placeholder={placeholder}
          aria-label="Search"
          onChange={(e) => {
            setValue(e.target.value);
          }}
          value={value}
        />
        {value && (
          <button
            type="reset"
            className={`ss-delete ${styles['clear-search']}`}
            aria-label="Clear Search"
            onClick={clearSearch}
          />
        )}

        <button type="submit" className={`${styles['submit-search']} ${value.length > 1 ? styles.active : ''}`}>
          <img src={`/images/search.png`} alt={formatCommonMessage({ id: 'search.icon', defaultMessage: 'Search' })} />
        </button>
      </Form>
    </div>
  );
};
